<template>
  <div>
    <NavBtns></NavBtns>

    <!--品牌理念-->
    <section id="abouta">
      <div class="titlebox">
        <div class="title">{{ $t('message.au_brand_mind_title') }}</div>
        <div class="text1">{{ $t('message.au_brand_mind') }}</div>
        <div class="stext" v-html="$t('message.au_brand_desc')"></div>
      </div>
      <div class="aboutA1 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a01.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA2 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a02.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA3 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a03.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA4 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a04.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA5 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a05.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA6 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a06.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="aboutA7 animated">
        <img
          class="img-fluid"
          src="../assets/images/about_a07.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
    </section>

    <!--吉祥物-->
    <section id="aboutb">
      <div class="title">{{ $t('message.au_mascot_title') }}</div>
      <div class="aboutB1">
        <div class="aniowl"></div>
      </div>
      <div class="name wow">{{ $t('message.au_mascot_name') }}</div>
      <div class="orangebox2">
        <div class="text wow">
          {{ $t('message.au_mascot_personality') }}
          <p>{{ $t('message.au_mascot_love') }}</p>
        </div>
        <a
          href="https://store.line.me/stickershop/author/328181/zh-Hant"
          target="_blank"
        >
          <div class="row">
            <div class="col-xl-4 col-md-6">
              <div class="sticker wow">
                {{ $t('message.au_mascot_sticker') }}
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>

    <!--合作廠商-->
    <section id="aboutc">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="blackbox wow">{{ $t('message.au_partner') }}</div>
          </div>
          <div class="col-xl-12">
            <div class="allbox" v-if="!is_offline">
              <div class="row">
                <div
                  class="col-xl-4 col-lg-4 col-md-6"
                  v-for="(partner, index) in partners"
                  v-bind:key="index"
                >
                  <div class="imgbox">
                    <a
                      v-if="
                        partner.img_error === false &&
                        partner.url &&
                        partner.url.length > 0
                      "
                      :href="partner.url"
                      target="_blank"
                    >
                      <img
                        class="img-fluid"
                        :src="partner.img"
                        @error="vSetImgError(index)"
                      />
                    </a>
                    <img
                      v-else-if="partner.img_error === false"
                      class="img-fluid"
                      :src="partner.img"
                      @error="vSetImgError(index)"
                    />
                    <!--圖片載入異常時顯示-->
                    <div
                      class="offlinebox2"
                      :class="{ show: partner.img_error }"
                    >
                      <div class="offallbox">
                        <div class="imgbox2">
                          <img
                            class="img-fluid"
                            src="../assets/images/offline.svg"
                            alt="offline"
                          />
                        </div>
                        <div class="text">
                          {{ $t('message.pb_no_picture') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--離線提示-->
            <div class="offlinebox" :class="{ show: is_offline || is_no_data }">
              <div class="offallbox">
                <div class="imgbox">
                  <img
                    class="img-fluid"
                    src="../assets/images/offline.svg"
                    alt="offline"
                  />
                </div>
                <div class="text">
                  {{
                    is_offline
                      ? $t('message.pb_offline')
                      : $t('message.au_partner_no_data')
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { WOW } from 'wowjs';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';
import Public from '@/scripts/public';

export default {
  name: 'About',
  components: {
    NavBtns,
    GzFooter,
  },
  data: function () {
    return {
      partner_api: Public.appGetAPIURL('partner'),
      partners: [],
    };
  },
  computed: {
    //網路連線狀態
    is_offline: function () {
      return this.net_offline && this.partners.length <= 0;
    },
    is_no_data: function () {
      return !this.partners || this.partners.length <= 0;
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  mounted: function () {
    //動畫處理
    new WOW().init();

    //取得合作廠商
    this.vLoadPartners();
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得合作廠商
      this.vLoadPartners();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
    //從cache / 網路載入合作廠商
    vLoadPartners: function () {
      var ref = this;
      if (!this.partner_api || this.partner_api.length <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.partner_api).then((data) => {
        ref.vRenderPartners(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.partner_api).then((data) => {
        ref.vRenderPartners(data);
      });
    },
    //依資料重新渲染畫面
    vRenderPartners: function (partners_data) {
      //為圖片設定載入成功與否的註記
      if (partners_data && partners_data.length > 0) {
        for (var i = 0; i < partners_data.length; i++) {
          partners_data[i]['img_error'] = false;
        }
      }
      //強制重新 render
      this.partners = [];
      this.partners =
        partners_data && partners_data.length > 0 ? partners_data : [];
    },
    //當圖片載入錯誤時
    vSetImgError: function (partner_idx) {
      if (this.partners[partner_idx]) {
        this.partners[partner_idx]['img_error'] = true;
      }
      //強制 render 畫面
      var origin_data = this.partners;
      this.partners = [];
      this.partners = origin_data;
    },
  },
  watch: {
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
